import { lazy, Suspense, useEffect, useRef, useState } from 'react';

const Ferrofluid = lazy(() => import('../../components/effects/Ferrofluid'));
const darkColors = ['#ffffff', '#d8d8d8', '#f3f3f3'];
const lightColors = ['#151515', '#555555', '#262626'];

export default function HeroFerrofluid({ theme }) {
  const containerRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const hasWebGL =
      typeof window.WebGLRenderingContext !== 'undefined' ||
      typeof window.WebGL2RenderingContext !== 'undefined';
    if (!hasWebGL || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches)
      return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setActive(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => setActive(entry.isIntersecting), {
      rootMargin: '100px',
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="hero-ferrofluid" ref={containerRef} aria-hidden="true">
      {active && (
        <Suspense fallback={null}>
          <Ferrofluid
            colors={theme === 'light' ? lightColors : darkColors}
            speed={0.28}
            scale={1.2}
            turbulence={0.8}
            fluidity={0.14}
            rimWidth={0.17}
            sharpness={3.2}
            shimmer={0.7}
            glow={1.7}
            flowDirection="down"
            opacity={theme === 'light' ? 0.72 : 0.82}
            mouseInteraction
            mouseStrength={0.8}
            mouseRadius={0.28}
            dpr={1.25}
          />
        </Suspense>
      )}
    </div>
  );
}
